import { Tabs } from 'components/DesignSystem/Tabs';
import { REPORTS_LIST_TABLE, USE_TEMPLATE_FOR_REPORT } from 'components/widgets/ReportsHome/ReportsHome.consts';
import { useReportsHomeLogic } from 'components/widgets/ReportsHome/ReportsHome.logic';
import classes from 'components/widgets/ReportsHome/ReportsHome.module.scss';
import { ReportsListTable } from 'components/widgets/ReportsHome/ReportsListTable/ReportsListTable';
import { ReportsTemplates } from 'components/widgets/ReportsHome/ReportsTemplates/ReportsTemplates';

export const ReportsHome = () => {
    const { logic } = useReportsHomeLogic();

    return (
        <div className={classes.reportsHomeWrapper}>
            <div className={classes.reportsTabsWrapper}>
                <Tabs tabs={logic.tabList} value={logic.activeTab} onChange={logic.setActiveTab} />
            </div>
            {logic.activeTab === REPORTS_LIST_TABLE && <ReportsListTable />}
            {logic.activeTab === USE_TEMPLATE_FOR_REPORT && <ReportsTemplates />}
        </div>
    );
};
